import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from '../../../services/apiClient';

//  update user
export const updateUser = createAsyncThunk(
  'user/updateUser',
  async (userData, { rejectWithValue }) => {
    try {
      const storedData = JSON.parse(localStorage.getItem('authData'));
      const userId = storedData?.user?._id;
      const response = await apiClient.patch(
        `/users/${userId}`,
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Fetch user data thunk
export const fetchUserData = createAsyncThunk(
  'user/fetchUserData',
  async (_, { rejectWithValue }) => {
    try {
      const storedData = JSON.parse(localStorage.getItem('authData'));
      const userId = storedData?.user?._id;
      const response = await apiClient.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


//fetching other Users detaila
export const fetchUserById = createAsyncThunk(
  'user/fetchUserById',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


export const deleteAllUserData = createAsyncThunk(
  'user/deleteAllUserData',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiClient.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const acceptCashbotDisclaimer = createAsyncThunk(
  'user/acceptCashbotDisclaimer',
  async (_, { rejectWithValue }) => {
    try {
      const storedData = JSON.parse(localStorage.getItem('authData'));
      const userId = storedData?.user?._id;
      const response = await apiClient.patch(
        `/users/${userId}`,
        {
          cashbotDisclaimerAccepted: true,
          cashbotDisclaimerVersion: '1.0'
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    currentUser: null,
    loading: false,
    error: null,
    status: 'idle'
  },
  reducers: {
    clearUserError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch user data cases
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.currentUser = action.payload.data;
        state.error = null;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update user cases
      .addCase(updateUser.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.currentUser = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      })
      
      //Rmeove all the Data
      .addCase(deleteAllUserData.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAllUserData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.currentUser = action.payload;
      })
      .addCase(deleteAllUserData.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(acceptCashbotDisclaimer.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(acceptCashbotDisclaimer.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        if (state.currentUser) {
          state.currentUser.cashbotDisclaimerAccepted = true;
          state.currentUser.cashbotDisclaimerVersion = '1.0';
        }
      })
      .addCase(acceptCashbotDisclaimer.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      });

  }
});

// Export selectors
export const selectUser = (state) => state.user.currentUser;
export const selectUserLoading = (state) => state.user.loading;
export const selectUserError = (state) => state.user.error;
export const selectTrialUsed = (state) => state.user.currentUser?.trialUsed;
export const selectCashbotDisclaimerAccepted = (state) => 
  state.user.currentUser?.cashbotDisclaimerAccepted || false;



export const { clearUserError } = userSlice.actions;
export default userSlice.reducer;